import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SdohReferral } from '@core/model';
import { Observable, catchError, combineLatest, map, of } from 'rxjs';
import { AssessmentService } from '../service/assessment.service';

@Injectable({
  providedIn: 'root'
})
export class SdohReferralPreloadResolver {
  constructor(private readonly assessmentService: AssessmentService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<SdohReferral | null> {
    const referralId = route.params['rId'];
    const queryString = `?$top=10&$skip=0&$filter=referralId eq ${referralId}`;
    const getReferrals$ = combineLatest([
      this.assessmentService.getReferrals(queryString),
      this.assessmentService.getArchivedReferrals(queryString)
    ]);

    return getReferrals$.pipe(
      map(([referral, archivedReferral]) => {
        if (referral.items.length) {
          return referral.items[0];
        }
        if (archivedReferral.items.length) {
          return archivedReferral.items[0];
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }
}
